import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AddinTab, GlobalState } from "./global.types";

const initialState: GlobalState = {
  isComposeMode: false,
  isMaintenanceMode: false,
  activeTabId: AddinTab.Analysis,
  isAboutModalOpened: false,
};

const globalSlice = createSlice({
  initialState,
  name: "global",
  reducers: {
    switchAddinTab: (state, action: PayloadAction<AddinTab>) => {
      state.activeTabId = action.payload;
    },
    switchToComposeMode: (state) => {
      state.isComposeMode = true;
      state.activeTabId = AddinTab.Simulator;
    },
    switchToMaintenanceMode: (state) => {
      state.isMaintenanceMode = true;
    },
    openAboutModal: (state) => {
      state.isAboutModalOpened = true;
    },
    closeAboutModal: (state) => {
      state.isAboutModalOpened = false;
    },
  },
});

export const {
  switchAddinTab,
  switchToComposeMode,
  switchToMaintenanceMode,
  openAboutModal,
  closeAboutModal,
} = globalSlice.actions;

export const globalReducer = globalSlice.reducer;
